import React from 'react'
import App from './App';

const Application = () => {
    console.log("App")
    return (
        <React.Fragment>
            <App />
        </React.Fragment>
    )
}

export default Application;